import Loader from '~components/generic/loader/Loader';
import useAssetActions from '~modules/media-gallery/controller/useAssetActions';
import useSearch from '~modules/media-library/controller/useSearch';
import { LoadingError } from '~modules/media-library/view/LoadingError';
import { ResultList } from '~modules/media-library/view/ResultList/ResultList';

type MediaGalleryProps = {
  realm: string;
  query?: string;
};

export function MediaGallery({ realm, query = '' }: MediaGalleryProps) {
  const { resultAssetIds, resultCount, isLoading, onLoadMore, isError } = useSearch(realm, query);

  const AssetActions = useAssetActions();

  return (
    <div className="ml--module-view bg-gray w-full min-h-screen">
      {(isLoading || isError) && (
        <div className="absolute inset-0 flex items-center justify-center z-10 bg-gray bg-opacity-50">
          {isLoading && (
            <div className="relative w-16 h-8">
              <Loader absoluteCenter={true} />
            </div>
          )}
          {isError && <LoadingError />}
        </div>
      )}

      {Boolean(resultAssetIds) && (
        <ResultList
          assetIds={resultAssetIds}
          assetCount={resultCount}
          onLoadMore={onLoadMore}
          AssetActions={AssetActions}
        />
      )}
    </div>
  );
}
